import type { ReactNode } from 'react'

interface PageHeaderProps {
  title: ReactNode
  /** Рядом с заголовком слева (например, переключатель раздела). */
  titleAside?: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
  filters?: ReactNode
}

export function PageHeader({ title, titleAside, subtitle, actions, filters }: PageHeaderProps) {
  return (
    <div className="mb-4">
      {/* На узком экране действия переносятся под заголовок, а не наезжают на него. */}
      <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-3">
        <div className="flex-1">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <h1 className="font-[family-name:var(--stryzh-font-family-space-grotesk)] text-[length:var(--stryzh-font-size-hero)] font-semibold tracking-[var(--stryzh-letter-spacing-space-grotesk)] text-[color:var(--stryzh-color-text-primary)]">
              {title}
            </h1>
            {titleAside}
          </div>
          {subtitle != null && (
            <p className="mt-1 font-[family-name:var(--stryzh-font-family-inter)] text-[length:var(--stryzh-font-size-sm)] text-[color:var(--stryzh-color-text-secondary)]">
              {subtitle}
            </p>
          )}
        </div>
        {actions != null && (
          <div className="flex min-w-0 max-w-full flex-wrap items-center gap-2">{actions}</div>
        )}
      </div>
      {filters != null && (
        <div className="mt-3 flex flex-wrap items-center gap-3">{filters}</div>
      )}
    </div>
  )
}
